<div class="container-fluid pt-3">
    <div class="container-fluid" *ngIf="lot">
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.sourceLotUid">
                    Source Lot UID
                </label>
            </div>
            <div class="col">
                <truncate-span>{{lot.sourceUid}}</truncate-span>
            </div>
        </div>
        <div class="row mt-2 mb-3">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.sourceStockId">
                    Source Stock ID
                </label>
            </div>
            <div class="col">
                <truncate-span>{{lot.sourceStockId}}</truncate-span>
            </div>
        </div>
    </div>
</div>
